import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  tariffGetImage,
  tariffAddImage
} from "actions/chargers/tariff/actions";
import languages from "../../../../data/languages";
import getFilesUrl from "../../../../helpers/getFilesUrl";
import Translations from "./translations";

const languageTemplate = {
  title: "",
  description: "",
  priceName: "",
  language: "",
};

class EditModal extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    const { tariff } = this.props;
    this.state = {
      id: tariff ? tariff.id : false,
      country: tariff ? tariff.country : "",
      active: tariff ? tariff.active : false,
      price: tariff ? tariff.price : 0,
      duration: tariff ? tariff.duration : 0,
      rate: tariff ? tariff.rate : 0,
      order: tariff ? tariff.order : 0,
      type: tariff ? tariff.type : "FIXED",
      stationType: tariff ? tariff.stationType : "RELINK",

      translations: tariff ? tariff.translations : Object.keys(languages)
        .map(langKey => ({
          ...languageTemplate,
          language: langKey
        })),
      logo: tariff ? tariff.logo : {},

      previewImage: getFilesUrl(tariff.logo),
      imageFile: null,
    };
  }

  handleChangeImage = ev => {
    const file = ev.target.files[0];
    this.setState({
      previewImage: URL.createObjectURL(file),
      imageFile: file
    });
  };

  handleChangeLanguage = (lang, name, value) => {
    const translations = [...this.state.translations];

    const languageItemIndex = translations.findIndex(i => i.language === lang);
    const languageItem = (languageItemIndex === -1) ? { ...languageTemplate } : { ...translations[languageItemIndex] };

    languageItem.language = lang;
    languageItem[name] = value;

    this.setState({
      translations: [
        ...this.state.translations.filter(i => i.language !== lang),
        languageItem
      ]
    });
  };

  handleChangeForm = (ev) => {
    const {
      name,
      value
    } = ev.target;
    this.setState({
      [name]: value
    });
  };

  handleSubmit = () => {
    const data = Object.assign({}, this.state);
    if (!data.id) {
      delete data.id;
    }
    this.props.onSubmit(data);
  };

  render() {
    const {
      order,
      active,
      country,
      duration,
      rate,
      price,
      type,
      stationType,
      translations,

      previewImage,
    } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col-3">
            <div className="form-group">
              <label>Active</label>
              <select
                className="form-control form-control-sm"
                onChange={ev => this.setState({
                  active: Boolean(+ev.target.value)
                })}
                value={active ? "1" : "0"}
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>
          <div className="col-3">
            <div className="form-group">
              <label>Order</label>
              <input
                className="form-control form-control-sm"
                type="number"
                min={0}
                value={order}
                onChange={ev => this.setState({
                  order: +ev.target.value
                })}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <label>Country</label>
              <input
                className="form-control form-control-sm"
                type="text"
                value={country}
                name="country"
                onChange={this.handleChangeForm}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <label>Price</label>
              <input
                className="form-control form-control-sm"
                type="number"
                min={0}
                value={price}
                onChange={ev => this.setState({
                  price: +ev.target.value
                })}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <label>Duration</label>
              <input
                className="form-control form-control-sm"
                type="number"
                min={0}
                value={duration}
                onChange={ev => this.setState({
                  duration: +ev.target.value
                })}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="form-group">
              <label>Type</label>
              <select
                className="form-control form-control-sm"
                value={type}
                onChange={ev => this.setState({
                  type: ev.target.value
                })}
              >
                {["FIXED", "MINUTE_PER_MINUTE", "DAILY"].map(item => (
                  <option key={item} value={item}>{item}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="form-group">
              <label>Station Type</label>
              <select
                className="form-control form-control-sm"
                value={stationType}
                onChange={ev => this.setState({
                  stationType: ev.target.value
                })}
              >
                {["RELINK"].map(item => (
                  <option key={item} value={item}>{item}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="form-group">
              <label>Rate</label>
              <input
                className="form-control form-control-sm"
                type="number"
                min={0}
                value={rate}
                onChange={ev => this.setState({
                  rate: +ev.target.value
                })}
              />
            </div>
          </div>

          <div className="col-12">
            <Translations
              translations={translations}
              onChange={this.handleChangeLanguage}
            />
          </div>

          <div className="col-12">
            <label>Image</label>
            <input
              className="form-control"
              accept="image/*"
              type="file"
              name="image"
              placeholder="Upload Image"
              onChange={this.handleChangeImage}
            />
            {previewImage && (
              <div className="mb-3 text-center">
                <img
                  src={previewImage}
                  alt="Preview"
                  className="img-thumbnail"
                  style={{
                    maxWidth: "100%",
                    width: "auto",
                    marginTop: 20
                  }}
                />
              </div>
            )}
          </div>
        </div>

        <div className="text-right mt-2">
          <button
            className="btn btn-danger mr-2"
            onClick={this.props.onCancel}
          >
            Cancel
          </button>
          <button
            className="btn btn-success"
            onClick={this.handleSubmit}
          >
            Save
          </button>
        </div>
      </div>
    );
  }
}

EditModal.propTypes = {
  tariff: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  tariffImage: state.chargerTariff.tariffImage,
});

const mapStateToDispatch = dispatch => ({
  tariffGetImage: bindActionCreators(tariffGetImage, dispatch),
  tariffAddImage: bindActionCreators(tariffAddImage, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(EditModal);



// WEBPACK FOOTER //
// ./src/views/pages/chargers/tariff/edit-modal.js